import(/* webpackMode: "eager" */ "/home/runner/work/rocola.it/rocola.it/packages/frontend/app/page.tsx");
